/* eslint-disable react-hooks/exhaustive-deps */
import { connect } from 'react-redux';
import React, { useRef } from 'react';
import Identification from '../../widgets/identification';
import KeyCompletedTasks from '../../widgets/key-completed-tasks';
import { actions } from '../../../../../../../store/reducers/dashboard';
import useFetchHelper from '../../../../../../../helpers/useFetchHelper';

const InformationContributions = ({
  t = (s) => s,
  data,
  PmeProjectGetWithFilters,
  contributorsTasks,
  valToResetFilters = null,
  language,
  settings,
}) => {
  const ref = useRef();
  const { canFetch } = useFetchHelper({ ref });

  return (
    <>
      <div className="multi-section" id="5a" ref={ref}>
        <div className="section-col">
          <section style={{ marginTop: 0 }}>
            <div className="main">
              <Identification
                t={t}
                data={data}
                language={language}
                canFetch={canFetch}
                valToResetFilters={valToResetFilters}
                PmeProjectGetWithFilters={PmeProjectGetWithFilters}
                settings={settings}
              />
              <KeyCompletedTasks
                t={t}
                data={contributorsTasks}
                language={language}
                canFetch={canFetch}
                PmeProjectGetWithFilters={PmeProjectGetWithFilters}
                valToResetFilters={valToResetFilters}
                settings={settings}
              />
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default connect(null, actions)(InformationContributions);
